// extracted by mini-css-extract-plugin
export default {"post":"NewsDetail_post__4Ddv0","post__title":"NewsDetail_post__title__iLWVV","post__backButton":"NewsDetail_post__backButton__dFijd"};